import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.75 14.298a8.25 8.25 0 1 0 16.5 0 8.25 8.25 0 1 0-16.5 0m.908-3.75h14.684m-7.342 0v12"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.292 11.351a5.23 5.23 0 0 0-2.792-.8m0 10.497a5.24 5.24 0 0 0 3.926-1.765M1.5 15.048h2.285m15.923-3.697a5.23 5.23 0 0 1 2.792-.8m0 10.497a5.24 5.24 0 0 1-3.926-1.765m3.926-4.235h-2.285M5.96 1.5c0 2.937.228 4.027 2.687 5.258M17.96 1.5c0 2.937-.228 4.027-2.687 5.258"
    }, null, -1)
  ]));
}
const programmingBug = { render };
export {
  programmingBug as default,
  render
};
//# sourceMappingURL=programming-bug.svg.js.map
